// Scrive un valore in un <input>/<textarea> controllato React e ne forza il rilevamento.
// La tecnica "native setter + input event" da sola a volte non basta: React tiene un
// `_valueTracker` interno con l'ultimo valore visto; se non lo aggiorniamo, può considerare
// l'input event un "no-op" e non chiamare onChange → il valore viene subito riscritto al vecchio
// dal ri-render controllato. Impostando il tracker al valore PRECEDENTE, React vede prev !== new
// e chiama onChange. Dispatch di 'input' e 'change' per coprire ogni handler.
export function setNativeInputValue(el: HTMLInputElement | HTMLTextAreaElement, value: string): void {
  const proto = el instanceof HTMLTextAreaElement ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
  const setter = Object.getOwnPropertyDescriptor(proto, 'value')?.set;
  const prev = el.value;
  if (setter) setter.call(el, value);
  else el.value = value;
  const tracker = (el as unknown as { _valueTracker?: { setValue: (v: string) => void } })._valueTracker;
  if (tracker) tracker.setValue(prev);
  el.dispatchEvent(new Event('input', { bubbles: true }));
  el.dispatchEvent(new Event('change', { bubbles: true }));
}
